import { useAuth } from '@/providers/AuthProvider';
import { AppShell, BackgroundImage, Box, Burger, Container, Grid } from '@mantine/core';
import { ActionHeader } from './ActionHeader';
import classes from './Header.module.css';
import { HeaderStatus } from './HeaderStatus';
import { LoginButtonMobile } from './LoginButtonMobile';
import { Logo } from './Logo';
export type HeaderTopProps = {
  opened: boolean;
  toggle: () => void;
};
export const HeaderTop: React.FC<HeaderTopProps> = ({
  opened,
  toggle
}) => {
  const {
    isLogin
  } = useAuth();
  return <AppShell.Header withBorder={false} py={10} w="100%">
      <Container fluid h="100%" style={{
      zIndex: 100
    }}>
        <BackgroundImage h="100%" src="/assets/menu-dark-bg.svg" className={classes.headerBg}>
          <Box h={100}>
            <Grid h="100%">
              <Burger opened={opened} onClick={toggle} color="var(--text-white)" size="md" hidden />
              <Grid.Col span={{
              base: 3.6,
              sm: 3.4,
              lg: 5
            }} ml={{
              base: 8,
              sm: 0
            }}>
                <Logo hiddenFrom="sm" />
                <HeaderStatus />
              </Grid.Col>
              <Grid.Col span={{
              base: isLogin ? 0.1 : 4,
              sm: 0.1,
              lg: 2
            }} p={0}>
                <Logo visibleForm="lg" />
                {!isLogin && <LoginButtonMobile />}
              </Grid.Col>
              <Grid.Col span={{
              base: isLogin ? 8 : 4,
              sm: 8.5,
              lg: 5
            }}>
                <ActionHeader />
              </Grid.Col>
            </Grid>
          </Box>
        </BackgroundImage>
      </Container>
    </AppShell.Header>;
};